import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveyHeadingTextElement extends SurveyElement {
  @Expose()
  text!: string;

  @Expose()
  size!: number;
}
